export default __webpack_public_path__ + "static/media/stamp_4.fe9c54b3.png";